import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const DeleteAccount: React.FC = () => {
     const [email, setEmail] = useState<string>('');
     const [otp, setOtp] = useState<string>('');
     const [step, setStep] = useState<number>(1);
     const [message, setMessage] = useState<string>('');
     const { t } = useTranslation();

     const sendOtp = async () => {
          try {
               const res = await fetch(
                    `https://indeeclips.com/api/rest/user/forgotPassword/${encodeURIComponent(email)}`,
                    { method: 'POST' }
               );
               const msg = await res.text();
               setStep(2);
               setMessage('OTP has been sent to your email.');
          } catch (err) {
               setMessage('Something went wrong.');
          }
     };

     const verifyOtpAndDelete = async () => {
          try {
               const res = await fetch(
                    `https://indeeclips.com/api/rest/user/verifyOtpAndDelete?email=${encodeURIComponent(email)}&otp=${encodeURIComponent(otp)}`,
                    { method: 'POST' }
               );
               const msg = await res.text();
               setMessage(msg);
               setStep(3);
          } catch (err) {
               setMessage('Something went wrong.');
          }
     };

     return (
          <div style={styles.container}>
               <h2>{t("deleteAccount.title")}</h2>
      <p>{t("deleteAccount.description")}</p>

               {step === 1 && (
                    <div>
                         <input
                              type="email"
                               placeholder={t("deleteAccount.emailPlaceholder")}
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              style={styles.input}
                              required
                         />
                         <button onClick={sendOtp} style={styles.button}>
                              {t("deleteAccount.sendOtp")}
                         </button>
                    </div>
               )}

               {step === 2 && (
                    <div>
                         <input
                              type="text"
                              placeholder={t("deleteAccount.otpPlaceholder")}
                              value={otp}
                              onChange={(e) => setOtp(e.target.value)}
                              style={styles.input}
                              required
                         />
                         <button onClick={verifyOtpAndDelete} style={styles.button}>
                              {t("deleteAccount.verifyAndDelete")}
                         </button>
                    </div>
               )}

               {(step === 2 || step === 3) && <p>{message}</p>}

               {step === 3 && (
                    <p style={{ marginTop: '10px', color: '#555' }}>
                         {t("deleteAccount.reactivateNote")}{" "}
                         <strong>{t("deleteAccount.supportEmail")}</strong>
                    </p>
               )}
          </div>
     );
};

const styles: { [key: string]: React.CSSProperties } = {
     container: {
          fontFamily: 'Arial, sans-serif',
          //     backgroundColor: '#f4f4f4',
          padding: '20px',
          maxWidth: '500px',
          margin: 'auto',
     },
     input: {
          width: '100%',
          padding: '10px',
          margin: '10px 0',
          border: '1px solid #ccc',
          borderRadius: '4px',
     },
     button: {
          backgroundColor: '#e60023',
          color: 'white',
          padding: '10px 20px',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
     },
};

export default DeleteAccount;